import { __asyncGenerator, __await } from "tslib";
import { AsyncIterableX } from './asynciterablex.mjs';
import { throwIfAborted } from '../aborterror.mjs';
/** @ignore */
export class OfAsyncIterable extends AsyncIterableX {
    constructor(args) {
        super();
        this._args = args;
    }
    [Symbol.asyncIterator](signal) {
        return __asyncGenerator(this, arguments, function* _a() {
            throwIfAborted(signal);
            for (const item of this._args) {
                yield yield __await(item);
            }
        });
    }
}
/**
 * Creates an async-iterable from the specified elements.
 *
 * @template TSource The type of the elements to create an async-iterable sequence.
 * @param {...TSource[]} args The elements to turn into an async-iterable sequence.
 * @returns {AsyncIterableX<TSource>} The async-iterable sequence created from the elements.
 */
export function of(...args) {
    return new OfAsyncIterable(args);
}

//# sourceMappingURL=of.mjs.map
